import Tray from './index'
import { assign } from 'lodash'
import React from 'react'
import Modal from '~/components/Modal'
import VideoJSPlayer from '~/components/VideoPlayer'

class PreviewTray extends React.Component {
  constructor(props) {
    super(props)
    this.options = {
      noPlayIcon: true,
      noBoxshadow: true,
      isEpisode: true,
      noEpisodeNumber: true
    }
    this.state = {
      videoId: null,
      videoTitle: '',
    }
    assign(props.data, this.options)
    this.openEpisodeOverlay = this.openEpisodeOverlay.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openEpisodeOverlay(e, index){
    e.preventDefault()
    const gist = this.props.data.contentData[index].gist
    this.setState({
      videoId: gist.id,
      videoTitle: gist.title,
      isModelOpen: true
    })
    document.body.classList.add('overflow-hide')
  }

  closeModal(){
    this.setState({
      isModelOpen: false
    })
    document.body.classList.remove('overflow-hide')
  }

  render() {
    return (
      <div className="preview-tray">
        <Tray {...this.props} openEpisodeOverlay={this.openEpisodeOverlay} />
        {this.state.isModelOpen ? (
          <Modal
            title={this.state.videoTitle}
            shown={this.state.isModelOpen}
            closeModal={this.closeModal}
            className="modal-anim"
            children={
              <VideoJSPlayer
                autoplay={true}
                videoId={this.state.videoId}
              />
            }
          />
        ) : (
            ''
          )}
      </div>
    )
  }
}

export default PreviewTray
